export const PAGINATION_SIZE = 8;
export const DEFAULT_GRID_IMG_LOAD_EAGER_COUNT = 4;
export const ATTR_LOADING_EAGER = 'eager';

export function getImageLoadingPriority(
  index: number,
  maxEagerLoadCount = DEFAULT_GRID_IMG_LOAD_EAGER_COUNT,
) {
  return index < maxEagerLoadCount ? ATTR_LOADING_EAGER : undefined;
}

export const LOCAL_STORAGE = {
  PAGES: '@PAGES',
};

export const SECTION_TYPES = {
  HERO_SECTION: 'hero',
  TEXT_IMAGE: 'text_image',
  IMAGE_TEXT: 'image_text',
  PAGE_BANNER: 'page_banner',
  PRODUCTS: 'products',
  ARTICLES: 'articles',
  FAQS: 'q&a',
  FEATURES: 'features',
};
